import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { passwordMatchingValidator } from '@shared/feature/forms';

import { InputDisplay, InputFieldType } from '@shared/ui/inputs';
import { EditProfileService } from '../../services/edit-profile.service';
import { Patterns } from '@shared/utils/patterns';

@Component({
    selector: 'sh-shared-layout-change-password-dialog',
    templateUrl: './change-password-dialog.component.html',
    styleUrls: ['./change-password-dialog.component.css'],
    standalone: false
})
export class ChangePasswordDialogComponent implements OnInit {
  reactiveForm = new FormGroup(
    {
      password: new FormControl('', [Validators.required, Validators.maxLength(16), Validators.minLength(8), Validators.pattern(Patterns.Password)]),
      confirmPassword: new FormControl('', [Validators.required, Validators.maxLength(16), Validators.minLength(8), Validators.pattern(Patterns.Password)]),
    },
    { validators: passwordMatchingValidator() }
  );

  type = InputFieldType.Password;
  display = InputDisplay.Inline;
  constructor(public service: EditProfileService) {}

  ngOnInit(): void {}

  saveData(): void {
    const newPassword = this.reactiveForm.controls['password'].value;
    if (newPassword) {
      this.service.editPassword(newPassword);
    }
  }
}
